<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import FeaturedArticles from '$lib/PageSections/FeaturedArticles/FeaturedArticles.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import OurLocation from '$lib/PageSections/OurLocation/OurLocation.svelte';

	import mediaKitImage from '../images/media-hub-001.jpg';
</script>

<Section backgroundColor="white">
	<div
		class="
    gap-20 pb-10
    md:flex md:gap-28
    [&_h2]:pb-8 [&_h2]:text-lg [&_h2]:uppercase
    [&_ul]:pb-16
  "
	>
		<div>
			<h2>Read</h2>
			<ul>
				<li>
					<a
						href="https://www.popularmechanics.com/home/interior-projects/how-to/g2470/soundproofing-a-room/"
						>Popular Mechanics</a
					>
				</li>
				<li>
					<a
						href="https://www.residentialsystems.com/technology/lighting-shades/indow-window-inserts-meet-a-variety-of-needs"
						>Residential Systems</a
					>
				</li>
				<li>
					<a
						href="https://www.retrofitmagazine.com/aerc-rates-labels-and-certifies-the-energy-performance-of-window-attachment-products-for-commercial-applications/2/"
						>AERC Certifies Indow</a
					>
				</li>
				<li>
					<a
						href="http://www.thebluebook.com/san-francisco-bay-area/articles/f21-fs2-where%E2%80%99s-the-pane.html"
						>Blue Book Bay Area - Where's the Pane</a
					>
				</li>
				<li>
					<a
						href="https://www.housebeautiful.com/home-remodeling/diy-projects/a36790852/how-to-soundproof-windows/"
						>House Beautiful - Soundproof Windows</a
					>
				</li>
				<li>
					<a
						href="https://thriveglobal.com/stories/how-sam-pardue-and-indow-have-helped-to-block-over-50000-tons-of-carbon-emissions-with-penny-bauder/"
						>How Indow blocked over 50k tons of carbon</a
					>
				</li>
				<li>
					<a
						href="https://www.workdesign.com/2020/01/using-well-as-a-guide-for-healthy-workplace-environment-design/"
						>Using WELL as a Guide for Healthy Workplace Environment Design</a
					>
				</li>
				<li>
					<a
						href="https://www.traditionalbuilding.com/product-report/combat-noise-pollution"
						>Traditional Building - Product Report - Noise Mitigation</a
					>
				</li>
				<li>
					<a
						href="https://www.moneypit.com/fix-improve-it/windows-doors/windows/interior-window-inserts-offer-cost-effective-comfort-and-energy-savings/"
						>The Money Pit - Cost Savings</a
					>
				</li>
				<li>
					<a href="https://www.yellowbrickhome.com/indow-storm-windows/"
						>Yellow Brick Home</a
					>
				</li>
				<li>
					<a href="https://www.marthastewart.com/1541391/how-soundproof-windows"
						>Martha Stewart</a
					>
				</li>
				<li>
					<a
						href="https://americanfarmhousestyle.com/design/indow-window-inserts/"
						>American Farmhouse Style</a
					>
				</li>
				<li>
					<a
						href="https://www.wweek.com/promotions/2019/08/08/better-portland-businesses-working-to-make-a-sustainable-future-for-our-city/"
						>Willamette Week - Better Portland</a
					>
				</li>
				<li>
					<a
						href="https://www.superbcrew.com/indow-is-changing-the-storm-window-market-through-their-innovative-designs-and-information-processing/	"
						>Superb Crew Business News</a
					>
				</li>
				<li>
					<a
						href="https://workdesign.com/2019/05/good-office-design-includes-soundproofing-for-productivity/"
						>Good Office Design Includes Soundproofing For Productivity</a
					>
				</li>
				<li>
					<a
						href="https://www.oldhouseonline.com/repairs-and-how-to/adding-comfort-to-historic-townhouses"
						>Old House Journal (June 2018)</a
					>
				</li>
				<li>
					<a
						href="https://www.proremodeler.com/innovative-products-indow-windows-interior-window-inserts"
						>Pro Remodeler Magazine</a
					>
				</li>
				<li>
					<a
						href="https://www.inc.com/magazine/201804/hannah-wallace/destination-portland-oregon.html?cid=hmsub1"
						>Inc.</a
					>
				</li>
				<li>
					<a
						href="https://savingplaces.org/stories/how-this-business-helps-make-saving-historic-windows-paneless-for-nonprofits"
						>National Trust for Historic Preservation</a
					>
				</li>
				<li>
					<a
						href="https://www.bobvila.com/articles/replacement-windows-vs-indow-windows/?bv=ca"
						>Bob Vila</a
					>
				</li>
				<li>
					<a href="https://www.thisoldhouse.com/ideas/new-life-old-windows"
						>This Old House</a
					>
				</li>
				<li>
					<a
						href="https://www.bloomberg.com/news/articles/2013-11-12/paleo-dieters-who-want-to-sleep-in-caves-lift-a-window-insert-maker#p1"
						>Bloomberg Businessweek</a
					>
				</li>
				<li>
					<a
						href="https://www.sunset.com/home/old-house-hack-making-old-windows-more-efficient"
						>Sunset Magazine</a
					>
				</li>
				<li>
					<a
						href="https://www.treehugger.com/sustainable-product-design/save-your-windows-and-your-money-indow-window-inserts.html"
						>Treehugger</a
					>
				</li>
				<li>
					<a
						href="http://nomnompaleo.com/post/55156756199/surviving-the-night-shift"
						>Nom Nom Paleo</a
					>
				</li>
				<li>
					<a href="https://www.wired.com/2015/01/growth-science/">Wired</a>
				</li>
				<li>
					<a
						href="https://www.oregonbusiness.com/100best/companies/100bestlogos/item/14980-the-carbon-calculus?showall=1"
						>Oregon Business</a
					>
				</li>
				<li>
					<a
						href="https://www.nytimes.com/2014/09/21/fashion/the-paleo-lifestyle-the-way-way-way-back.html?_r=0"
						>New York Times</a
					>
				</li>
				<li>
					<a
						href="https://www.pdxmonthly.com/articles/2014/11/3/portland-windows-shine-a-light-on-ai-weiweis-alcatraz-art-october-2014"
						>Portland Monthly</a
					>
				</li>
				<li>
					<a
						href="http://golocalpdx.com/arts/portland-made-product-innovator-sam-pardue-of-indow"
						>GoLocalPDX</a
					>
				</li>
				<li>
					<a href="http://www.myhomescience.com/hate-drafty-windows/"
						>My Home Science</a
					>
				</li>
				<li>
					<a
						href="https://greenbuildingelements.com/2014/12/12/save-energy-winter/"
						>Green Building Elements</a
					>
				</li>
				<li>
					<a
						href="https://www.dailyherald.com/article/20150201/entlife/150209966/"
						>Chicago Daily Herald</a
					>
				</li>
				<li>
					<a
						href="https://www.oregonlive.com/living/index.ssf/2013/01/easy_fixes_can_warm_your_winte.html"
						>The Oregonian</a
					>
				</li>
				<li>
					<a
						href="https://www.bizjournals.com/portland/blog/sbo/2014/12/indow-continues-to-rake-in-the-green-window-honors.html"
						>Portland Business Journal</a
					>
				</li>
				<li>
					<a
						href="https://www.usglassmag.com/2014/08/window-company-develops-correction-alcatraz/"
						>US Glass</a
					>
				</li>
				<li>
					<a
						href="http://old.seattletimes.com/html/homesrealestate/2024345453_hreecoconsumer24xml.html"
						>Seattle Times</a
					>
				</li>
				<li>
					<a
						href="https://www.huffingtonpost.com/carrie-sturrock/build-community_b_5531039.html"
						>Huffington Post</a
					>
				</li>
				<li>
					<a
						href="https://www.huffingtonpost.com/carrie-sturrock/sleep_b_4849993.html"
						>Huffington Post</a
					>
				</li>
				<li>
					<a
						href="http://www.remodeling.hw.net/products/7-products-to-get-you-warmed-up-for-winter_o"
						>Remodeling Magazine</a
					>
				</li>
				<li>
					<a
						href="https://energypriorities.com/2013/04/behavior-modification-via-indow-window-inserts/"
						>Energy Priorities</a
					>
				</li>
				<li>
					<a
						href="https://greenlivingguy.com/2014/09/05/energy-efficient-window-inserts-by-indow-windows-keep-you-warm/"
						>Green Living Guy</a
					>
				</li>
				<li>
					<a
						href="https://www.bizjournals.com/portland/blog/sbo/2014/04/indow-windows-takes-home-high-profile.html"
						>Sustainable Business Oregon</a
					>
				</li>
			</ul>
		</div>

		<div>
			<h2>Listen</h2>
			<ul>
				<li>
					<a
						href="https://practicalpreservationservices.com/practical-preservation-podcast-featuring-sam-pardue-of-indow-windows/"
						>Practical Preservation Podcast</a
					>
				</li>
				<li>
					<a href="https://littlezsleep.com/blog/our-indow-windows-review/"
						>Little Z's Sleep Podcast</a
					>
				</li>
				<li>
					<a
						href="https://www.moneypit.com/listen-watch/the-money-pit-podcast/window-inserts-that-stop-drafts-how-to-save-on-carpet-quick-crack-repairs/"
						>The Money Pit Podcast</a
					>
				</li>
				<li>
					<a
						href="https://soundcloud.com/user-401408772/sam-pardue-ceo-founder-of-indow-windows"
						>PDX Executive Podcast</a
					>
				</li>
				<li>
					<a
						href="https://www.preservecast.org/2018/05/21/keeping-original-windows-sam-pardue-indow/"
						>Preservation Podcast</a
					>
				</li>
				<li><a href="http://ow.ly/2Tck30jehy3">Biz503</a></li>
				<li>
					<a
						href="https://www.kink.fm/episode-20-features-sam-pardue-indow-window/"
						>Talking Trash: A Green Tips Podcast</a
					>
				</li>
			</ul>

			<h2>Videos</h2>
			<ul>
				<li>
					<a href="https://youtu.be/TdNOArzN6Sc"
						>Little Z | Indow Sleep Panel Review</a
					>
				</li>
				<li><a href="https://youtu.be/4Tizzpcfmm0">DIY Mom</a></li>
				<li>
					<a href="https://youtu.be/kcGl32P5iMg"
						>How to Soundproof a Window | Indow Window Inserts</a
					>
				</li>
				<li>
					<a href="https://youtu.be/iLXkRg7Pp2U"
						>Energy Efficient America Talks Sustainability with Indow</a
					>
				</li>
				<li>
					<a href="https://www.youtube.com/watch?v=fVmuIKQraUE"
						>A Storm Window That Works From the Inside, Out!</a
					>
				</li>
				<li>
					<a href="https://youtu.be/eIZpQpx0b0M"
						>Destroy Outside Noise With Indow Window Inserts!</a
					>
				</li>
				<li>
					<a href="https://www.youtube.com/watch?v=SdB7Oj1Ayv4"
						>The Craftsman Blog</a
					>
				</li>
				<li>
					<a href="https://youtu.be/lUIRQdgq1HE">Vintage Revivals</a>
				</li>
			</ul>

			<h2>Awards</h2>
			<ul>
				<li>
					<a
						href="https://www.oen.org/2020/11/19/2020-oen-entrepreneurship-award-winners/"
						>OEN Entrepreneurs Awards - Give Award 2020</a
					>
				</li>
				<li>
					<a
						href="http://www.bizjournals.com/portland/blog/2015/10/meet-the-2015-oregon-manufacturing-awards-winners.html"
						>Portland Business Journal - Oregon Manufacturing Award</a
					>
				</li>
				<li>
					<a
						href="https://www.environmentalleader.com/2014/03/announcing-el-product-project-award-winners-2014/"
						>Environmental Leader</a
					>
				</li>
				<li>
					<a
						href="https://www.oen.org/2013/09/17/winners-and-finalists-2013-oen-awards/"
						>Oregon Entrepreneurs Network - Tom Holce Award, Finalist, 2013</a
					>
				</li>
				<li>
					<a href="http://www.edisonawards.com/winners2012.php">Edison Awards</a
					>
				</li>
				<li>
					<a
						href="http://www.dwell.com/event-spotlight/slideshow/highlights-greenbuild-2012#9"
						>Dwell - Top 10 Product, Greenbuild 2012</a
					>
				</li>
				<li>
					<a
						href="https://www.treehugger.com/clean-technology/winners-of-cleantech-open-2011-announced.html"
						>Clean Tech Open - National Category Winner, Energy Efficiency &
						Sustainability, 2011</a
					>
				</li>
				<li>
					<a
						href="http://www.portlandoregon.gov/sustainabilityatwork/article/460535"
						>Sustainability at Work - Gold Certified 2013-2023</a
					>
				</li>
			</ul>
		</div>
	</div>
	<Image src={mediaKitImage} class="w-full" alt="Indow Windows in the Media" />
</Section>

<GetAFreeEstimate />

<OurLocation backgroundColor="grey" class="w-full" />

<FeaturedArticles />
